module.exports = __webpack_public_path__ + "static/p06_ganso-2417e77ec05497ab3c5e52ab2dbdf606.png";